
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 8","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.2 7.9L.1 6.8 2.9 4 .1 1.2 1.2.1 4 2.9 6.8.1l1.1 1.1L5.1 4l2.8 2.8-1.1 1.1L4 5.1 1.2 7.9z"}})])
          )
        }
      }
    